import VimeoPlayer from '@vimeo/player';
import { youtubePlayerFor } from './youtube-player';
import { VideoAnalytics } from './video-analytics';

// The YouTube API has no time event, so a playing video is polled.
const YOUTUBE_POLL_MS = 500;

const videoCategory = iframe => iframe.dataset.videoCategory || 'Video';

const trackVimeoIframe = iframe => {
  const category = videoCategory(iframe);
  const player = new VimeoPlayer(iframe);
  let video = { category, id: '', title: 'Vimeo' };
  Promise.all([player.getVideoId(), player.getVideoTitle()])
    .then(([id, title]) => {
      video = { category, id, title: title || `Vimeo ${id}` };
    })
    .catch(() => {});

  const analytics = new VideoAnalytics(() => video);
  player.on('play', () => analytics.play());
  player.on('timeupdate', ({ seconds, percent }) =>
    analytics.timeUpdate(seconds, percent)
  );
  player.on('pause', ({ percent }) => analytics.pause(percent));
  player.on('ended', () => analytics.complete());
};

const trackYoutubeIframe = iframe => {
  const category = videoCategory(iframe);

  youtubePlayerFor(iframe).then(player => {
    const { video_id: id = '', title = '' } = player.getVideoData() || {};
    const analytics = new VideoAnalytics(() => ({
      category,
      id,
      title: title || `YouTube ${id}`,
    }));
    const percent = () => {
      const duration = player.getDuration();
      return duration ? player.getCurrentTime() / duration : 0;
    };

    let poll;
    const stopPolling = () => clearInterval(poll);
    player.addEventListener('onStateChange', ({ data }) => {
      const { PLAYING, PAUSED, ENDED } = window.YT.PlayerState;
      if (data === PLAYING) {
        analytics.play();
        stopPolling();
        poll = setInterval(
          () => analytics.timeUpdate(player.getCurrentTime(), percent()),
          YOUTUBE_POLL_MS
        );
      } else if (data === PAUSED) {
        stopPolling();
        analytics.pause(percent());
      } else if (data === ENDED) {
        stopPolling();
        analytics.timeUpdate(player.getDuration(), 1);
        analytics.complete();
      }
    });
  });
};

// Vimeo and YouTube iframes in page markup (CEU, older content blocks and
// carousels). <vimeo-video> tracks itself; set data-video-category on the
// iframe to name where it sits. YouTube frames need enablejsapi=1 in src.
export const trackEmbeddedVideos = (root = document) => {
  root.querySelectorAll('iframe[src]').forEach(iframe => {
    if (iframe.dataset.videoTracked) return;
    const src = iframe.getAttribute('src');

    if (src.includes('player.vimeo.com/video/')) {
      iframe.dataset.videoTracked = 'true';
      trackVimeoIframe(iframe);
    } else if (
      src.includes('youtube.com/embed/') &&
      src.includes('enablejsapi=1')
    ) {
      iframe.dataset.videoTracked = 'true';
      trackYoutubeIframe(iframe);
    }
  });
};
